<h2 mat-dialog-title>{{ 'E-mail módosítása' | translate }}</h2>
<mat-dialog-content>
  <p>
    {{
      'E-mail címed módosításához kérjük írd be a használni kívánt új e-mail címed!'
        | translate
    }}
  </p>

  <form [formGroup]="emailForm">
    <mat-form-field appearance="outline">
      <mat-label>{{ 'E-mail' | translate }}</mat-label>
      <input
        formControlName="newEmail"
        matInput
        [placeholder]="'E-mail' | translate" />
    </mat-form-field>
    <mat-error *ngIf="emailForm.controls.newEmail.hasError('required')">
      {{ 'Kérjük adj meg egy e-mail címet!' | translate }}
    </mat-error>
    <mat-error *ngIf="emailForm.controls.newEmail.hasError('email')">
      {{ 'Kérjük valós e-mail címet adj meg!' | translate }}
    </mat-error>
    <mat-error *ngIf="emailForm.controls.newEmail.hasError('stringNotEquals')">
      {{
        'E-mail címed módosításához írd be a használni kívánt új e-mail címét!'
          | translate
      }}
    </mat-error>
  </form>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>{{ 'Mégse' | translate }}</button>
  <button
    mat-button
    color="primary"
    [mat-dialog-close]="emailForm.value.newEmail"
    [disabled]="!emailForm.valid">
    <span translate>{{ 'Módosítás' | translate }}</span>
  </button>
</mat-dialog-actions>
